import {css} from '../theme/css'
import {createSvgIcon} from './utils'

const className = css`
  width: 6px;
  height: 10px;
  margin-inline-start: 2px;
`

export default createSvgIcon(
  <svg fill="none" height="10" viewBox="0 0 6 10" width="6" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1.50098L4.5 5.00098L1 8.50098" stroke="currentColor" strokeLinecap="round" strokeWidth="1.25" />
  </svg>,
  'MicroChevronRight',
  {className, viewBox: '0 0 6 10', rtlTransform: true},
)
